import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-xl border border-white/10 bg-slate-950/50 px-3 py-2 text-base text-white shadow-sm transition-all duration-300 placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-0 focus:ring-0 focus:border-emerald-500/40 focus:shadow-[0_0_20px_rgba(16,185,129,0.15)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
